import { API_URL } from "../config/api";

// Simple notification interface matching API response
export interface Notification {
  id: string;
  user_id: string;
  message: string;
  entity_type: string;
  entity_id: string;
  link: string | null;
  is_read: boolean;
  created_at: string;
}

// Query parameters
export interface NotificationParams {
  page?: number;
  size?: number;
  unread_only?: boolean;
}

// API response
export interface NotificationResponse {
  results: Notification[];
  count: number;
  next?: string;
  previous?: string;
}

// Get notifications
export const getNotifications = async (
  token: string,
  unread_only: boolean = false,
  page: number = 1,
  size: number = 50
): Promise<NotificationResponse> => {
  let url = `${API_URL}/notifications/?page=${page}&size=${size}`;
  
  if (unread_only === false) {
    url += '&unread_only=false';
  }
  
  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  
  if (!response.ok) {
    throw new Error(`API Error: ${response.status}`);
  }
  
  const data = await response.json();
  return data;
};

// Mark notification as read
export const markAsRead = async (token: string, notificationId: string): Promise<void> => {
  const response = await fetch(`${API_URL}/notifications/${notificationId}/read`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  
  if (!response.ok) {
    throw new Error(`Failed to mark as read: ${response.status}`);
  }
};

// Mark all as read
export const markAllAsRead = async (token: string): Promise<void> => {
  const response = await fetch(`${API_URL}/notifications/mark-all-read`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  
  if (!response.ok) {
    throw new Error(`Failed to mark all as read: ${response.status}`);
  }
};

// Delete all notifications
export const deleteAllNotifications = async (token: string): Promise<void> => {
  const response = await fetch(`${API_URL}/notifications/`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });
  
  if (!response.ok) {
    throw new Error(`Failed to delete all: ${response.status}`);
  }
}; 